import { useQuery } from '@tanstack/react-query';
import { profileClient } from 'api/MinSideClients';

export const currentPermissionsQueryKey = ['currentPermissions'];

// Delt cache for rettighetene til innlogget bruker. Ligger i UserProvider, som aldri
// unmountes, så cachen må invalideres eksplisitt når brukeren får nye rettigheter.
export function useCurrentPermissionsQuery(enabled: boolean) {
  return useQuery({
    queryKey: currentPermissionsQueryKey,
    enabled,
    queryFn: () => profileClient.apiProfileCurrentPermissionsGet()
  });
}
